// extracted by mini-css-extract-plugin
module.exports = {"loaderWrap":"Loader_loaderWrap__3X_q_","loaderContent":"Loader_loaderContent__24i6o"};